jQuery(function($) {

  // Update circle.js element with % value
  var asPercent = function(value) {
    return value + '%';
  }

  $('#gift-cards').waypoint({
    element: this,
    handler: function(direction) {

      var graphGiftCards = Circles.create({
        id:           'graph-giftcards-pie',
        radius:       70,
        value:        118,
        maxValue:     118,
        width:        2,
        text:         function(value) {return '$'+value+'<div class="tiny">bn</div>';},
        colors:       ['#DCDEE2', '#525E71'],
        duration:       1000,
        styleWrapper: false,
        styleText:    false
      });

      var graphGiftCards = Circles.create({
        id:           'graph-giftcards-buy',
        radius:       70,
        value:        93,
        maxValue:     100,
        width:        2,
        text:         asPercent,
        colors:       ['#DCDEE2', '#525E71'],
        duration:       1000,
        styleWrapper: false,
        styleText:    false
      });

      var graphGiftCards = Circles.create({
        id:           'graph-giftcards-spend',
        radius:       70,
        value:        72,
        maxValue:     100,
        width:        2,
        text:         asPercent,
        colors:       ['#DCDEE2', '#525E71'],
        duration:       1000,
        styleWrapper: false,
        styleText:    false
      });

      this.destroy();
    },
    offset: '50%'
  });
});